import React, { ChangeEventHandler, ReactElement, useState } from "react";
import classnames from "classnames";

import styles from "../../styles/MultiSelectDropdown.module.scss"

export type ItemProps = {
  id: string,
  content:ReactElement|string
  checked:boolean
}

type DropdownItemProps = ItemProps&{
  onChecked?:(checked:boolean)=>void
}

export type OnCheckedHandler = (key:string, checked:boolean) => void

export type Props = {
  buttonContent: ReactElement|string
  items?: ItemProps[]
  className?: string,
  onChecked?: OnCheckedHandler
}

function DropdownItem({content,id,checked,onChecked}:DropdownItemProps):ReactElement {
  let handleSelect:undefined|ChangeEventHandler = undefined
  if (onChecked !== undefined) {
    handleSelect = () => {
      onChecked(!checked)
    }
  }

  return (
    <div className={styles.checkboxWrapper}>
      <input
        type="checkbox"
        name={id}
        id={id}
        checked={checked}
        onChange={handleSelect}
      /><label className={styles.checkbox} htmlFor={id}>
      <span></span>
    </label>
        {content}

    </div>
  )
}

function renderList(open:boolean, setOpen:Function,items: ItemProps[], onChecked?:OnCheckedHandler): ReactElement|undefined {
  function handleChecked (key:string, checked:boolean) {
    if (onChecked !== undefined) {
      onChecked(key, checked)
    }
  }

  return (
    <div className={styles.listcontent}>
      <div
        className={styles.closeArea}
        onClick={()=>setOpen(!open)}>
      </div>
      <ul className={styles.list}>
        {
          items.map((item) => {
            return (
              <li key={item.id}>
                <DropdownItem
                  id={item.id}
                  content={item.content}
                  checked={item.checked}
                  onChecked={handleChecked.bind({}, item.id)}
                />
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export function MultiSelectDropdown({
  buttonContent,
  items=[],
  className,
  onChecked
}:Props): ReactElement {
  const [open, setOpen] = useState<boolean>(false)
  return (
    <div className={classnames(styles.multiList, className)}>
      <button className={styles.openButton} onClick={() => setOpen(!open)}>{buttonContent}</button>
      {renderList(open, setOpen,items, onChecked)}
    </div>
  )
}
